import logo from '../assets/logo.png'

export default {
    logo,
}